var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-button",class:{ active: _vm.active },on:{"click":_vm.clickHandler}},[_vm._v("\n    "+_vm._s(_vm.options.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }